import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

export const useVideoCallStatus = () => {
  const trans = useSelector(translator);

  return {
    calling: trans('CALLING'),
    ringing: trans('RINGING'),
    accepted: trans('ACCEPTED'),
    joining: trans('JOINING'),
    incall: trans('INCALL'),
    leaving: trans('LEFTCALL'),
    declined: trans('CALLDECLINED'),
    missed: trans('NORESPONSE'),
    busy: trans('BUSY'),
    failed: trans('INVITEFAILED'),
    unreachable: trans('UNREACHABLE'),
  };
};
